export default __webpack_public_path__ + "static/media/img_papaground09.cf11c647.jpg";